<div #power style="height: 92vh;" powerbi-settings-filter-pane-enabled="false">  </div>
